import { FormatTypes } from 'Lib/Format';
import { Field, NumericInput, TextOutput } from '../../Core';
import { ListFieldSection, PageSection } from '../../Layout';

const DeflectionGaugeEquipment = () => {
  return (
    <PageSection>
      <ListFieldSection>
        <Field input={<TextOutput />} label="Deflection Gauge" name="Code" />
        <Field
          format={{ type: FormatTypes.AsEntered }}
          input={<NumericInput />}
          label="Readable to Nearest"
          name="Readability"
        />
      </ListFieldSection>
    </PageSection>
  );
};

export default DeflectionGaugeEquipment;
export { DeflectionGaugeEquipment };
